import { ServiceProvider } from "./ServiceProvider";


const BASE_URL = ServiceProvider.liveService.base;

class LiveService {
  // GET all records
  static getLiveServices() {
    return new Promise((resolve, reject) => {
      fetch(ServiceProvider.liveService.getAll)
        .then((res) => res.json())
        .then((result) => resolve(result.data || result))
        .catch((error) => {
          console.error("Error fetching live_service data:", error);
          reject(error);
        });
    });
  }

  // GET single record by ID
  static getLiveServiceById(id) {
    return new Promise((resolve, reject) => {
      fetch(ServiceProvider.liveService.getById + id)
        .then((res) => res.json())
        .then((result) => resolve(result.data || result))
        .catch((error) => {
          console.error(`Error fetching live_service with id ${id}:`, error);
          reject(error);
        });
    });
  }

  // CREATE new record
  static createLiveService(data) {
    const reqData = { cmp_ids: [data.cmp_id] };
    console.log(reqData)
    return new Promise((resolve, reject) => {
      fetch(ServiceProvider.liveService.insert, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqData),
      })
        .then(async (response) => {
          const result = await response.json();
          if (!response.ok) return reject(result.message || 'Failed to create record');
          resolve(result.data || result);
        })
        .catch((error) => {
          console.error("Error creating live_service:", error);
          reject(error);
        });
    });
  }

  // Start service
  static startLiveService(data) {
    console.log(JSON.stringify(data, null, 2))
    return new Promise((resolve, reject) => {
      fetch(ServiceProvider.liveService.start, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then(async (response) => {
          const result = await response.json();
          if (!response.ok) return reject(result.message || 'Failed to start service');
          resolve(result.data || result);
        })
        .catch((error) => {
          console.error("Error starting live_service:", error);
          reject(error);
        });
    });
  }

  // Stop service
  static stopLiveService(data) {
    return new Promise((resolve, reject) => {
      fetch(ServiceProvider.liveService.stop, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then(async (response) => {
          const result = await response.json();
          if (!response.ok) return reject(result.message || 'Failed to stop service');
          resolve(result.data || result);
        })
        .catch((error) => {
          console.error("Error stoping live_service:", error);
          reject(error);
        });
    });
  }

  // UPDATE existing record
  static updateLiveService(id, data) {
    return new Promise((resolve, reject) => {
      fetch(ServiceProvider.liveService.update + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then(async (response) => {
          const result = await response.json();
          if (!response.ok) return reject(result.message || 'Failed to update record');
          resolve(result.data || result);
        })
        .catch((error) => {
          console.error(`Error updating live_service with id ${id}:`, error);
          reject(error);
        });
    });
  }

  // DELETE record
  static deleteLiveService(id) {
    return new Promise((resolve, reject) => {
      fetch(ServiceProvider.liveService.delete + id, { method: 'DELETE' })
        .then(async (response) => {
          const result = await response.json();
          if (!response.ok) return reject(result.message || 'Failed to delete record');
          resolve(result);
        })
        .catch((error) => {
          console.error(`Error deleting live_service with id ${id}:`, error);
          reject(error);
        });
    });
  }

  // GET paginated records
  static getLiveServicesPaginated(page = 1, limit = 10) {
    return new Promise((resolve, reject) => {
      fetch(`${ServiceProvider.liveService.getAll}?page=${page}&limit=${limit}`)
        .then((res) => res.json())
        .then((result) => resolve(result))
        .catch((error) => {
          console.error("Error fetching paginated live_service data:", error);
          reject(error);
        });
    });
  }

  // GET filter records
  static getFilterData(strDate, stpDate, sts, exchange) {
    console.log(`${ServiceProvider.liveService.base}/filter?start_date=${strDate}&end_date=${stpDate}&sts=${sts}&exchange=${exchange}`)
    return new Promise((resolve, reject) => {
      fetch(
        `${ServiceProvider.liveService.base}/filter?start_date=${strDate}&end_date=${stpDate}&sts=${sts}&exchange=${exchange}`
      )
        .then((res) => res.json())
        .then((result) => resolve(result.data))
        .catch((error) => {
          console.error("Error fetching filter live_service data:", error);
          reject(error);
        });
    });
  }

}

export default LiveService;
